module.exports = __webpack_public_path__ + "img/dearness.341247ef.png";